import { z } from 'zod';

export interface WorkoutComment {
  readonly id: string;
  readonly sessionId: string;
  readonly authorProfileId: string;
  readonly authorDisplayName: string;
  readonly authorIsGhost: boolean;
  readonly body: string;
  readonly readAt: string | null;
  readonly createdAt: string;
}

export const newCommentSchema = z.object({
  body: z
    .string()
    .trim()
    .min(1, { message: 'Введи комментарий' })
    .max(2000, { message: 'Слишком длинный комментарий' }),
});

export type NewCommentInput = z.infer<typeof newCommentSchema>;
